import type DevtoolsStateTypeMemberType from './member/devtools.stateType.member';
import type { Dispatch } from 'react';

export default interface DevtoolsStateType extends DevtoolsStateTypeMemberType {
  enabled: boolean;
}

export type DevtoolsContextType = {
  state: DevtoolsStateType;
  dispatch: Dispatch<DevtoolsReducerActionType>;
};

export enum DEVTOOLS_TYPES {
  INIT = 'init',
  DEVTOGGLE_DEVTOOL = 'DEVTOGGLE_DEVTOOL',
  MEMBER_SAVE = 'MEMBER_SAVE',
  MEMBER_RESET = 'MEMBER_RESET',
}

export interface DevtoolsReducerActionType {
  type: DEVTOOLS_TYPES;
  payload?: Partial<DevtoolsStateType>;
}
